var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.668.295a.5.5 0 0 1 .664 0l.886.787a.5.5 0 0 0 .483.102l1.13-.358a.5.5 0 0 1 .606.27l.49 1.08a.5.5 0 0 0 .4.29l1.177.132a.5.5 0 0 1 .444.493l.008 1.185a.5.5 0 0 0 .247.428l1.022.6a.5.5 0 0 1 .206.63l-.475 1.086a.5.5 0 0 0 .052.492l.69.963a.5.5 0 0 1-.07.66l-.875.8a.5.5 0 0 0-.153.47l.239 1.16a.5.5 0 0 1-.332.575l-1.124.374a.5.5 0 0 0-.331.367l-.254 1.157a.5.5 0 0 1-.538.39l-1.179-.115a.5.5 0 0 0-.451.2l-.703.955a.5.5 0 0 1-.65.138l-1.03-.586a.5.5 0 0 0-.494 0l-1.03.586a.5.5 0 0 1-.65-.138l-.703-.954a.5.5 0 0 0-.451-.201l-1.18.116a.5.5 0 0 1-.537-.39l-.254-1.158a.5.5 0 0 0-.33-.367l-1.125-.374a.5.5 0 0 1-.332-.575l.239-1.16a.5.5 0 0 0-.153-.47l-.875-.8a.5.5 0 0 1-.07-.66l.69-.963a.5.5 0 0 0 .052-.492L.569 5.935a.5.5 0 0 1 .206-.632l1.022-.6a.5.5 0 0 0 .247-.427l.008-1.185a.5.5 0 0 1 .444-.493l1.178-.132a.5.5 0 0 0 .4-.29l.489-1.08a.5.5 0 0 1 .606-.27l1.13.358a.5.5 0 0 0 .483-.102l.886-.787Z",
    fill: "#523DF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5 8 1.859 1.859a.2.2 0 0 0 .282 0L11 6",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/verification.4832c18b7eba3aee8a25b86e938bbf11.svg";